import Env from '../../Env';

// Robovoice standard name
export const ROBOVOICE = 'robovoice';

// The endpoint for the robovoice audio
// and .marks files
export const API_URL = Env.ROBOVOICE_URL;

export const AUDIO_FAILED_TO_PULL_MESSAGE = 'audio failed to fetch';

// placeholder text to store in asset cache while an asset is currently downloading
export const DOWNLOADING = 'downloading...';

export const ReduxActions = {
  REGISTER_ROBOTEXT: 'REGISTER_ROBOTEXT',
  UNREGISTER_ROBOTEXT: 'UNREGISTER_ROBOTEXT',
  INIT_ROBOTEXT: 'INIT_ROBOTEXT',
};

// Types of robovoice resources
export const ResourceTypes = {
  AUDIO: 'audio',
  MARKS: 'marks',
};

// Types describing network call status
export const FetchStatus = {
  SUCCESS: 'success',
  CACHE_HIT: 'cache_hit',
  ERROR: 'error',
};
